// /* eslint-disable array-callback-return */
// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useState, useEffect, useMemo } from "react";
// import { Paper, Button } from "@mui/material";
// import { Grid, Select, MenuItem, Tooltip } from "@mui/material";
// import { grey } from "@mui/material/colors";
// import { ThemeProvider, createTheme } from "@mui/material/styles";

// import { useSelector, useDispatch } from "react-redux";
// import { fetchScoringCriteria } from "../store/TestScoringCriteriaMgmtSlice";
// import {
//   fetchTestResvInfobyUnitCode,
//   fetchTestResvInfobyResvDate,
//   addCandAtDueDate,
// } from "../store/TestReservationSlice";

// import { countryarr, rtafunitarr } from "./GlobalUseData";
// /*------------------------ Date Picker : BuddhistEra --------------*/
// import OwnDatePicker from "./OwnDatePicker";
// import { toast } from "react-toastify";

// /*------------------------ Theme ---------------------------------*/
// const theme = createTheme({
//   typography: {
//     allVariants: {
//       fontFamily: "THSarabunNew",
//       fontSize: 14,
//     },
//   },
//   components: {
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           backgroundColor: grey["100"],
//           border: "1px solid blue",
//         },
//       },
//     },
//     MuiGrid: {
//       styleOverrides: {
//         root: {
//           alignItems: "center",
//         },
//       },
//     },
//   },
// });

// /*----------------------- TbSelectTestDateAndTime -------------------------------*/
// function TbSelectTestDateAndTime(props) {
//   /*----------------------- Redux --------------------------*/
//   const scoringcriteria = useSelector(
//     (state) => state.scoringcriteriastate.scoringcriteria
//   );
//   //let _scoringcriteria = [{ 'scoringcriteriacode': 'INIT', 'mission': 'เลือกเหตุผล' }, ...scoringcriteria];
//   let _scoringcriteria = [
//     { scoringcriteriacode: "INIT", mission: "เลือกเหตุผล" },
//     ...Object.assign([], scoringcriteria),
//   ];
//   _scoringcriteria.splice(1, 1);
//   const scoringcriteriadispatch = useDispatch();
//   useEffect(() => {
//     scoringcriteriadispatch(fetchScoringCriteria());
//   }, [scoringcriteriadispatch]);

//   /*----------------------- Creat Reservation Code ----------------------*/
//   const testresvinfo = useSelector(
//     (state) => state.testresvinfostate.testresvarr
//   );

//   const testresvinfodispatch = useDispatch();

//   /*---------------------- Reason/Country/DatePeriod -------------------*/
//   const [newdate, setNewDate] = useState(props.date);
//   const [selectscc, setSelectScc] = useState("เลือกเหตุผล"); //Reason changed
//   const [selcountry, setSelCountry] = useState(0); //Country changed
//   const [selresvperiod, setSelResvPeriod] = useState("เลือกช่วงเวลาสอบ"); //---> updated on 21-10-2024
//   //const [selresvperiod, setSelResvPeriod] = useState('0900 - 1000'); //Period changed

//   /***********************************************************************/
//   /*-------------------- added on 31-03-2024 ----------------------------*/
//   /***********************************************************************/
//   const bookdatelist = useSelector((state) => state.bookdate.bookdatearr);
//   let seldatelist = bookdatelist.filter((date) => {
//     return date.start.split("T")[0] === newdate;
//   }); //*** updated on 08-10-2024 */
//   //console.log('SelectTestDateAndTime --->', seldatelist, ' : ', newdate, ' : ', bookdatelist, ' : ', props.date, ' : ', selresvperiod);

//   /*-------------------- added on 21-10-2024 : to remove blocked period -------------------------*/
//   let t_period = [
//     "เลือกช่วงเวลาสอบ",
//     "0900 - 1000",
//     "1030 - 1130",
//     "1330 - 1430",
//   ];
//   seldatelist
//     .filter((item) => item.extendedProps.resvcode.includes("LOC"))
//     .map((currentValue) => {
//       t_period = t_period.filter((t) => {
//         return !t.includes(currentValue.extendedProps.resvcode.split("-")[1]);
//       });
//     });

//   /*---------------------- Create Memberlist ---------------------------*/
//   const [detailslist, setDetailsList] = useState({});
//   const { user } = useSelector((state) => state.user);
// // console.log("testresvinfo",testresvinfo)
//   const orgname = user.orgname;
//   useEffect(() => {
//     let initstate = {
//       resvcode: testresvinfo?.data,
//       date: newdate,
//       period: selresvperiod,
//       reason: selectscc,
//       country: countryarr[selcountry],
//       member: [],
//     };

//     // console.log('initstate --->', initstate , ' : ' , testresvinfo?.data)
//     // console.log('initstate --->', rtafunitarr)


//     testresvinfodispatch(fetchTestResvInfobyUnitCode(rtafunitarr[orgname])); //changed code according to user
//     testresvinfodispatch(fetchTestResvInfobyResvDate(newdate)); //change date
//     testresvinfodispatch(addCandAtDueDate(initstate));
//     setDetailsList(initstate);
//     props.hidecheckingpanelfunc(false);
//   }, [newdate, selectscc, selcountry, selresvperiod, testresvinfo?.data,testresvinfodispatch]);

//   const updatememberlist = useSelector(
//     (state) => state?.testresvinfostate?.candAtDueDateArr
//   );

//   useMemo(() => {
//     if (Object.keys(updatememberlist).length === 0) {
//       setDetailsList({
//         resvcode: testresvinfo?.data,
//         date: newdate,
//         period: selresvperiod,
//         reason: selectscc,
//         country: countryarr[selcountry],
//         member: [],
//       });
//     } else {
//       setDetailsList(updatememberlist);
//     }
//   }, [updatememberlist?.member?.length]);

//   //console.log('TbSelectTestDateAndTime -> updatememberlist ', updatememberlist['member']?.length, ' : detailslist -> ', detailslist['member']?.length)
//   /*---------------------- add Member in the List ---------------------------*/
//   const addMemberInDetailedList = () => {
//     let newdetailslist = Object.assign({}, detailslist);
//     //console.log('120 TbSelectTestDateAndTime ---> newdetailslist : ', newdetailslist, ' : props --> ', props.meminfolist)

//     if (props.meminfolist) {
//       //let found = detailslist['member'].some(mbr => {
//       let found = newdetailslist["member"].some((mbr) => {
//         return mbr.pers_id === props.meminfolist.pers_id;
//         //return Object.entries(mbr).toString() === Object.entries(props.meminfolist).toString();
//       });

//       if (!found) {
//         toast(`เพิ่มรายชื่อผู้เข้าสอบเรียบร้อยแล้ว`, {
//           position: toast.POSITION.TOP_CENTER,
//         });
//         let tmparr = [...detailslist["member"]];
//         tmparr.push(
//           Object.assign(Object.assign({}, props.meminfolist), {
//             testlabroom: "lab0",
//           })
//         );
//         //tmparr.push(props.meminfolist);
//         setDetailsList(Object.assign(newdetailslist, { member: tmparr }));
//         //console.log('detailslist ---> ', detailslist, ' : newdetailslist ---> ', newdetailslist, ' : tmparr --->', tmparr, ' : props.meminfolist--->', props.meminfolist);
//       } else {
//         toast.warning(
//           `กรุณาตรวจสอบ ข้าราชการดังกล่าวมีข้อมูลอยู่ในรายชื่อผู้เข้าสอบเรียบร้อยแล้ว`,
//           { position: toast.POSITION.TOP_CENTER }
//         );
//       }
//     } else {
//       toast.warning(
//         "กรุณากรอกข้อมูลเลขประจำตัวประชาชน และชื่อ-นามสกุลให้ครบถ้วน",
//         { position: toast.POSITION.TOP_CENTER }
//       );
//     }

//     //setDetailsList(newdetailslist);
//     /********** under construction ----> change obj to obj array ********/
//     //console.log(' -------------> ', newdetailslist);
//     return newdetailslist;
//   };

//   /*------------------------ Return ------------------------*/
//   return (
//     <ThemeProvider theme={theme}>
//       <Paper elevation={0} sx={{ padding: 4 }}>
//         <Grid container spacing={2}>
//           <Grid
//             item
//             xs={12}
//             display={"flex"}
//             justifyContent={"center"}
//             sx={{ fontWeight: "bold" }}
//           >
//             เลือกวันและเวลาทดสอบ
//           </Grid>

//           <Grid
//             item
//             xs={3}
//             display={"flex"}
//             justifyContent={"flex-end"}
//             sx={{ fontWeight: "bold" }}
//           >
//             เหตุผลรับการทดสอบ:
//           </Grid>
//           <Grid item xs={3}>
//             <Select
//               id="scc_select"
//               value={selectscc}
//               fullWidth
//               onChange={(scc) => {
//                 /****** updated on 17-09-2024 *******************************************/
//                 if (scc.target.value === "ทดสอบภาษาอังกฤษประจำปี") {
//                   setSelCountry(5);
//                 }
//                 setSelectScc(scc.target.value);
//               }}
//             >
//               {
//                 /****** updated on 24-10-2024 *******************************************/
//                 //<MenuItem key={i} value={scc.mission}>{scc.mission}</MenuItem>
//                 Object.values(_scoringcriteria).map((scc, i) => {
//                   if (scc.mission === "ราชการต่างประเทศกรณีอื่นๆ") {
//                     return (
//                       <MenuItem key={i} value={scc.mission}>
//                         <Tooltip
//                           placement="right-end"
//                           title={
//                             <>
//                               <MenuItem value={i}>สัมมนา</MenuItem>
//                               <MenuItem value={i}>ฝึกอบรม</MenuItem>
//                               <MenuItem value={i}>
//                                 ฝึกอบรมเชิงปฏิบัติการ
//                               </MenuItem>
//                               <MenuItem value={i}>เข้าร่วมการแข่งขัน</MenuItem>
//                               <MenuItem value={i}>
//                                 การติดตามร่วมทีมแสดงความสามารถพิเศษ
//                               </MenuItem>
//                               <MenuItem value={i}>
//                                 ไปรับของรางวัลที่ต่างประเทศมอบให้
//                               </MenuItem>
//                             </>
//                           }
//                         >
//                           <div>{scc.mission}</div>
//                         </Tooltip>
//                       </MenuItem>
//                     );
//                   } else {
//                     return (
//                       <MenuItem key={i} value={scc.mission}>
//                         {scc.mission}
//                       </MenuItem>
//                     );
//                   }
//                 })
//               }
//             </Select>
//           </Grid>
//           <Grid
//             item
//             xs={2}
//             display={"flex"}
//             justifyContent={"flex-end"}
//             sx={{ fontWeight: "bold" }}
//           >
//             ประเทศปลายทาง:
//           </Grid>
//           <Grid item xs={4} display={"flex"} justifyContent={"flex-start"}>
//             <Select
//               value={selcountry}
//               fullWidth
//               onChange={(newCountry) => {
//                 //console.log('TbSelectTestDateAndTime selcountry ---->', newCountry.target.value);
//                 setSelCountry(newCountry.target.value);
//               }}
//             >
//               {countryarr.map((ctry, i) => {
//                 return (
//                   <MenuItem key={i} value={i}>
//                     {ctry}
//                   </MenuItem>
//                 );
//               })}
//             </Select>
//           </Grid>

//           <Grid
//             item
//             xs={3}
//             display={"flex"}
//             justifyContent={"flex-end"}
//             sx={{ fontWeight: "bold" }}
//           >
//             วันที่เข้ารับการทดสอบ:
//           </Grid>
//           <Grid item xs={9}>
//             <OwnDatePicker
//               date={props.date}
//               newdatefunc={props.newdatefunc}
//               onDateChange={setNewDate}
//             />
//           </Grid>

//           <Grid
//             item
//             xs={3}
//             display={"flex"}
//             justifyContent={"flex-end"}
//             sx={{ fontWeight: "bold" }}
//           >
//             ช่วงเวลา:
//           </Grid>
//           <Grid item xs={9}>
//             <Select
//               sx={{ minWidth: 150 }}
//               value={selresvperiod}
//               onChange={(period) => {
//                 setSelResvPeriod(period.target.value);
//               }}
//             >
//               {
//                 /****************** updated on 21-10-2024 ******************/
//                 /*['0900 - 1000', '1030 - 1130', '1330 - 1430'].map((item, i) =>
//                                     <MenuItem key={i} value={item}>{item}</MenuItem>
//                                 )*/
//                 t_period.map((item, i) => (
//                   <MenuItem key={i} value={item}>
//                     {item}
//                   </MenuItem>
//                 ))
//               }
//             </Select>
//           </Grid>

//           <Grid item xs={12}>
//             <Grid container spacing={2} justifyContent={"center"}>
//               <Grid item>
//                 <Button
//                   variant="contained"
//                   onClick={() => {
//                     /*--------------------- updated on 01-03-2024 --------------------*/
//                     if (selectscc !== "เลือกเหตุผล" && selcountry !== 0) {
//                       let _date = newdate.concat(
//                         "T",
//                         selresvperiod
//                           .split("-")[0]
//                           .replace(/(\d{2})(\d{2})/, "$1:$2")
//                       );
//                       let _lockdate = seldatelist
//                         .filter((item) =>
//                           item.extendedProps.resvcode.includes("LOC")
//                         )
//                         .filter((item) => item.start === _date.trim());

//                       /****************** updated on 21-10-2024 ******************/
//                       if (
//                         _lockdate.length > 0 ||
//                         selresvperiod === "เลือกช่วงเวลาสอบ"
//                       ) {
//                         toast.warning(
//                           "กรุณาเลือกวันและเวลาที่ต้องการเข้ารับการทดสอบใหม่อีกครั้ง",
//                           { position: toast.POSITION.TOP_CENTER }
//                         );
//                       } else {
//                         let res = testresvinfodispatch(
//                           addCandAtDueDate(addMemberInDetailedList())
//                         );

//                         if (res) {
//                           props.hidecheckingpanelfunc(true);
//                           //console.log('TbSelectTestDateAndTime --->', res);
//                         }
//                       }
//                     } else {
//                       toast.warning(
//                         "กรุณาเลือกเหตุผลรับการทดสอบและประเทศที่จะเดินทาง",
//                         { position: toast.POSITION.TOP_CENTER }
//                       );
//                     }
//                   }}
//                 >
//                   เพิ่มรายชื่อผู้เข้าสอบ
//                 </Button>
//               </Grid>
//               <Grid item>
//                 <Button
//                   variant="contained"
//                   onClick={() => {
//                     props.tabclosefunc(); //func in pagebookdate.jsx
//                   }}
//                 >
//                   ย้อนกลับ
//                 </Button>
//               </Grid>
//               <Grid item>
//                 {/*<Tooltip title='ตรวจสอบรายชื่อผู้เข้าสอบ'>
//                                     <IconButton
//                                         sx={{ color: blue['A700'] }}
//                                         onClick={() => {
//                                             props.hidecheckingpanelfunc(!props.checkpanelstate);
//                                         }}
//                                     >
//                                         <ViewListIcon />
//                                     </IconButton>
//                                     </Tooltip>
//                                 */}
//                 <Button
//                   variant="contained"
//                   onClick={() => {
//                     props.hidecheckingpanelfunc(!props.checkpanelstate);
//                   }}
//                 >
//                   ตรวจสอบข้อมูล
//                 </Button>
//               </Grid>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Paper>
//     </ThemeProvider>
//   );
// }

// export default TbSelectTestDateAndTime;



import React, { useState, useEffect, useMemo } from 'react';
import { Paper, Button } from '@mui/material';
import { Grid, Select, MenuItem, Tooltip } from '@mui/material';
import { grey } from '@mui/material/colors';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import { useSelector, useDispatch } from 'react-redux';
import { fetchScoringCriteria } from '../store/TestScoringCriteriaMgmtSlice';
import {
    fetchTestResvInfobyUnitCode,
    fetchTestResvInfobyResvDate,
    addCandAtDueDate
} from '../store/TestReservationSlice';

import { countryarr, rtafunitarr } from "./GlobalUseData";
/*------------------------ Date Picker : BuddhistEra --------------*/
import OwnDatePicker from './OwnDatePicker';
import { toast } from 'react-toastify';

/*------------------------ Theme ---------------------------------*/
const theme = createTheme({
    typography: {
        allVariants: {
            fontFamily: 'THSarabunNew',
            fontSize: 14
        }
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: grey['100'],
                    border: '1px solid blue'
                }
            }
        },
        MuiGrid: {
            styleOverrides: {
                root: {
                    alignItems: 'center'
                }
            }
        }
    }
});

/*----------------------- TbSelectTestDateAndTime -------------------------------*/
function TbSelectTestDateAndTime(props) {
    /*----------------------- Redux --------------------------*/
    const scoringcriteria = useSelector((state) => state.scoringcriteriastate.scoringcriteria);
    //let _scoringcriteria = [{ 'scoringcriteriacode': 'INIT', 'mission': 'เลือกเหตุผล' }, ...scoringcriteria];
    let _scoringcriteria = [
        { 'scoringcriteriacode': 'INIT', 'mission': 'เลือกเหตุผล' }, ...Object.assign([], scoringcriteria)
    ];
    _scoringcriteria.splice(1, 1);
    const scoringcriteriadispatch = useDispatch();
    useEffect(() => {
        scoringcriteriadispatch(fetchScoringCriteria());
    }, [scoringcriteriadispatch]);

    /*----------------------- Creat Reservation Code ----------------------*/
    const testresvinfo = useSelector((state) => state.testresvinfostate.testresvarr);
    const testresvinfodispatch = useDispatch();

    /*---------------------- Reason/Country/DatePeriod -------------------*/
    const [newdate, setNewDate] = useState(props.date);
    const [selectscc, setSelectScc] = useState('เลือกเหตุผล'); //Reason changed
    const [selcountry, setSelCountry] = useState(0); //Country changed
    const [selresvperiod, setSelResvPeriod] = useState('เลือกช่วงเวลาสอบ'); //---> updated on 21-10-2024
    //const [selresvperiod, setSelResvPeriod] = useState('0900 - 1000'); //Period changed

    /***********************************************************************/
    /*-------------------- added on 31-03-2024 ----------------------------*/
    /***********************************************************************/
    const bookdatelist = useSelector((state) => state.bookdate.bookdatearr);
    let seldatelist = bookdatelist.filter(date => { return (date.start.split('T')[0] === newdate) }); //*** updated on 08-10-2024 */
    //console.log('SelectTestDateAndTime --->', seldatelist, ' : ', newdate, ' : ', bookdatelist, ' : ', props.date, ' : ', selresvperiod);

    /*-------------------- added on 21-10-2024 : to remove blocked period -------------------------*/
    let t_period = ['เลือกช่วงเวลาสอบ', '0900 - 1015', '1030 - 1145', '1330 - 1445'];
    seldatelist.filter(
        item => item.extendedProps.resvcode.includes('LOC')
    ).map((currentValue) => {
        t_period = t_period.filter(t => { return !t.includes(currentValue.extendedProps.resvcode.split('-')[1]) });
    });

    /*---------------------- Create Memberlist ---------------------------*/
    const [detailslist, setDetailsList] = useState({});
    const { user } = useSelector((state) => state.user);
    const orgname = user.orgname;

    useEffect(() => {
        let initstate = {
            'resvcode': testresvinfo?.data,
            'date': newdate,
            'period': selresvperiod,
            'reason': selectscc,
            'country': countryarr[selcountry],
            'member': []
        }

        // console.log('initstate --->', initstate, ' : ', testresvinfo?.data, ' : ', rtafunitarr[orgname], ' : ', orgname)

        testresvinfodispatch(fetchTestResvInfobyUnitCode(rtafunitarr[orgname]))//changed code according to user 
        testresvinfodispatch(fetchTestResvInfobyResvDate(newdate)); //change date
        testresvinfodispatch(addCandAtDueDate(initstate));
        setDetailsList(initstate);
        props.hidecheckingpanelfunc(false);
    }, [newdate, selectscc, selcountry, selresvperiod]);

    const updatememberlist = useSelector((state) => state.testresvinfostate.candAtDueDateArr);

    useMemo(() => {
        if (Object.keys(updatememberlist).length === 0) {
            setDetailsList({
                'resvcode': testresvinfo?.data,
                'date': newdate,
                'period': selresvperiod,
                'reason': selectscc,
                'country': countryarr[selcountry],
                'member': []
            });
        } else {
            setDetailsList(updatememberlist);
        }
    }, [updatememberlist?.member?.length]);

    // console.log('TbSelectTestDateAndTime -> updatememberlist ', updatememberlist['member']?.length, ' : detailslist -> ', detailslist['member']?.length)
    /*---------------------- add Member in the List ---------------------------*/
    const addMemberInDetailedList = () => {
        let newdetailslist = Object.assign({}, detailslist);
        //console.log('120 TbSelectTestDateAndTime ---> newdetailslist : ', newdetailslist, ' : props --> ', props.meminfolist)

        if (props.meminfolist) {
            //let found = detailslist['member'].some(mbr => {
            let found = newdetailslist['member'].some(mbr => {
                return mbr.pers_id === props.meminfolist.pers_id;
                //return Object.entries(mbr).toString() === Object.entries(props.meminfolist).toString();
            });

            if (!found) {
                toast(`เพิ่มรายชื่อผู้เข้าสอบเรียบร้อยแล้ว`, { position: toast.POSITION.TOP_CENTER });
                let tmparr = [...detailslist['member']];
                tmparr.push(Object.assign(Object.assign({}, props.meminfolist), { 'testlabroom': 'lab0' }));
                //tmparr.push(props.meminfolist);
                setDetailsList(Object.assign(newdetailslist, { 'member': tmparr }));
                //console.log('detailslist ---> ', detailslist, ' : newdetailslist ---> ', newdetailslist, ' : tmparr --->', tmparr, ' : props.meminfolist--->', props.meminfolist);
            } else {
                toast.warning(
                    `กรุณาตรวจสอบ ข้าราชการดังกล่าวมีข้อมูลอยู่ในรายชื่อผู้เข้าสอบเรียบร้อยแล้ว`,
                    { position: toast.POSITION.TOP_CENTER }
                );
            }
        } else {
            toast.warning(
                'กรุณากรอกข้อมูลเลขประจำตัวประชาชน และชื่อ-นามสกุลให้ครบถ้วน',
                { position: toast.POSITION.TOP_CENTER }
            );
        }

        //setDetailsList(newdetailslist);
        /********** under construction ----> change obj to obj array ********/
        //console.log(' -------------> ', newdetailslist);
        return newdetailslist;
    };

    /*------------------------ Return ------------------------*/
    return (
        <ThemeProvider theme={theme}>
            <Paper elevation={0} sx={{ padding: 4 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}
                        display={'flex'}
                        justifyContent={'center'}
                        sx={{ fontWeight: 'bold' }}
                    >
                        เลือกวันและเวลาทดสอบ
                    </Grid>

                    <Grid item xs={3}
                        display={'flex'}
                        justifyContent={'flex-end'}
                        sx={{ fontWeight: 'bold' }}
                    >
                        เหตุผลรับการทดสอบ:
                    </Grid>
                    <Grid item xs={3}>
                        <Select id='scc_select'
                            value={selectscc}
                            fullWidth
                            onChange={(scc) => {
                                /****** updated on 17-09-2024 *******************************************/
                                if (scc.target.value === 'ทดสอบภาษาอังกฤษประจำปี') {
                                    setSelCountry(5);
                                }
                                setSelectScc(scc.target.value);
                            }}
                        >
                            {   /****** updated on 24-10-2024 *******************************************/
                                //<MenuItem key={i} value={scc.mission}>{scc.mission}</MenuItem>
                                Object.values(_scoringcriteria).map((scc, i) => {
                                    if (scc.mission === 'ราชการต่างประเทศกรณีอื่นๆ') {
                                        return (
                                            <MenuItem key={i} value={scc.mission}>
                                                <Tooltip
                                                    placement='right-end'
                                                    title={
                                                        <>
                                                            <MenuItem value={i}>สัมมนา</MenuItem>
                                                            <MenuItem value={i}>ฝึกอบรม</MenuItem>
                                                            <MenuItem value={i}>ฝึกอบรมเชิงปฏิบัติการ</MenuItem>
                                                            <MenuItem value={i}>เข้าร่วมการแข่งขัน</MenuItem>
                                                            <MenuItem value={i}>การติดตามร่วมทีมแสดงความสามารถพิเศษ</MenuItem>
                                                            <MenuItem value={i}>ไปรับของรางวัลที่ต่างประเทศมอบให้</MenuItem>
                                                        </>
                                                    }>
                                                    <div>{scc.mission}</div>
                                                </Tooltip>
                                            </MenuItem>
                                        );
                                    } else {
                                        return (<MenuItem key={i} value={scc.mission}>{scc.mission}</MenuItem>);
                                    }
                                })
                            }
                        </Select>
                    </Grid>
                    <Grid item xs={2}
                        display={'flex'}
                        justifyContent={'flex-end'}
                        sx={{ fontWeight: 'bold' }}
                    >
                        ประเทศปลายทาง:
                    </Grid>
                    <Grid item xs={4}
                        display={'flex'}
                        justifyContent={'flex-start'}
                    >
                        <Select value={selcountry} fullWidth onChange={(newCountry) => {
                            //console.log('TbSelectTestDateAndTime selcountry ---->', newCountry.target.value);
                            setSelCountry(newCountry.target.value);
                        }}>
                            {
                                countryarr.map((ctry, i) => {
                                    return (<MenuItem key={i} value={i}>{ctry}</MenuItem>)
                                })
                            }
                        </Select>
                    </Grid>

                    <Grid item xs={3}
                        display={'flex'}
                        justifyContent={'flex-end'}
                        sx={{ fontWeight: 'bold' }}
                    >
                        วันที่เข้ารับการทดสอบ:
                    </Grid>
                    <Grid item xs={9}>
                        <OwnDatePicker date={props.date} newdatefunc={props.newdatefunc} onDateChange={setNewDate} />
                    </Grid>

                    <Grid item xs={3}
                        display={'flex'}
                        justifyContent={'flex-end'}
                        sx={{ fontWeight: 'bold' }}
                    >
                        ช่วงเวลา:
                    </Grid>
                    <Grid item xs={9}>
                        <Select
                            sx={{ minWidth: 150 }}
                            value={selresvperiod}
                            onChange={(period) => {
                                setSelResvPeriod(period.target.value);
                            }}
                        >
                            { /****************** updated on 21-10-2024 ******************/
                                /*['0900 - 1000', '1030 - 1130', '1330 - 1430'].map((item, i) =>
                                    <MenuItem key={i} value={item}>{item}</MenuItem>
                                )*/
                                t_period.map((item, i) =>
                                    <MenuItem key={i} value={item}>{item}</MenuItem>
                                )
                            }
                        </Select>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid item>
                                <Button
                                    variant='contained'
                                    onClick={() => {
                                        /*--------------------- updated on 01-03-2024 --------------------*/
                                        if (selectscc !== 'เลือกเหตุผล' && selcountry !== 0) {
                                            let _date = newdate.concat('T', selresvperiod.split('-')[0].replace(/(\d{2})(\d{2})/, '$1:$2'));
                                            let _lockdate = seldatelist.filter(
                                                item => item.extendedProps.resvcode.includes('LOC')
                                            ).filter(item => item.start === _date.trim());

                                            /****************** updated on 21-10-2024 ******************/
                                            if (_lockdate.length > 0 || selresvperiod === 'เลือกช่วงเวลาสอบ') {
                                                toast.warning(
                                                    'กรุณาเลือกวันและเวลาที่ต้องการเข้ารับการทดสอบใหม่อีกครั้ง',
                                                    { position: toast.POSITION.TOP_CENTER }
                                                );
                                            } else {
                                                let res = testresvinfodispatch(
                                                    addCandAtDueDate(addMemberInDetailedList())
                                                );

                                                if (res) {
                                                    props.hidecheckingpanelfunc(true);
                                                    //console.log('TbSelectTestDateAndTime --->', res);
                                                }
                                            }
                                        } else {
                                            toast.warning(
                                                'กรุณาเลือกเหตุผลรับการทดสอบและประเทศที่จะเดินทาง',
                                                { position: toast.POSITION.TOP_CENTER }
                                            );
                                        }
                                    }}
                                >
                                    เพิ่มรายชื่อผู้เข้าสอบ
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant='contained'
                                    onClick={() => {
                                        props.tabclosefunc();//func in pagebookdate.jsx
                                    }}
                                >
                                    ย้อนกลับ
                                </Button>
                            </Grid>
                            <Grid item>
                                {/*<Tooltip title='ตรวจสอบรายชื่อผู้เข้าสอบ'>
                                    <IconButton
                                        sx={{ color: blue['A700'] }}
                                        onClick={() => {
                                            props.hidecheckingpanelfunc(!props.checkpanelstate);
                                        }}
                                    >
                                        <ViewListIcon />
                                    </IconButton>
                                    </Tooltip>
                                */}
                                <Button
                                    variant='contained'
                                    onClick={() => {
                                        props.hidecheckingpanelfunc(!props.checkpanelstate);
                                    }}
                                >
                                    ตรวจสอบข้อมูล
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </ThemeProvider>
    );
}

export default TbSelectTestDateAndTime;